import { TABLE_SORT_DIRECTION } from '../constants';
import { filterData } from './search';

export function applyClientSideActions<T extends Record<string, unknown>>(
  data: T[],
  searchString: string,
  sortKey: keyof T,
  sortDirection: TABLE_SORT_DIRECTION,
  offset: number,
  defaultLimit: number,
  SEARCH_KEYS: string[]
) {
  // Filtering
  const filteredData: T[] = filterData<T>(data, searchString, SEARCH_KEYS);

  // Sort
  const oppositeSortDirectionNum = -1 * sortDirection;

  const dataTransformer = (d: T[keyof T]) =>
    typeof d === 'string' ? d.toLowerCase() : d;

  const sortedData = [...filteredData].sort((a: T, b: T) => {
    const aValue = a[sortKey] && dataTransformer(a[sortKey]);
    const bValue = b[sortKey] && dataTransformer(b[sortKey]);
    if (!aValue && !bValue) return 0;
    else if (!aValue && bValue) return oppositeSortDirectionNum;
    else if (aValue && !bValue) return sortDirection;
    else if (aValue > bValue) return sortDirection;
    else if (aValue < bValue) return oppositeSortDirectionNum;
    else return 0;
  });

  // Pagination
  const pageOfProjects = sortedData.slice(offset, offset + defaultLimit);

  return {
    data: pageOfProjects,
    recordCount: filteredData.length,
  };
}
